import _Typography from "@mui/material/Typography";
import { ThemeProvider } from '@mui/material/styles';
import React from 'react';
import { Trans } from 'react-i18next';
import { styled } from 'styled-components';
import { useUnits } from '../../hooks';
import { cyclingProfiles } from '../../models';
import { PublicTransportIcon } from '../icons';
export function SelectedRoutePopup({
  theme,
  routes: {
    cyclingProfile,
    hasPublicTransportsSection,
    distances: {
      total: distance
    },
    cyclingDistance,
    duration,
    cyclingDuration,
    description
  },
  showDescription
}) {
  const {
    toDistance,
    toTime
  } = useUnits();
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(StyledHeader, null, hasPublicTransportsSection ? /*#__PURE__*/React.createElement(PublicTransportIcon, null) : cyclingProfile && cyclingProfiles[cyclingProfile]?.icon, /*#__PURE__*/React.createElement(_Typography, {
    color: "primary"
  }, toTime(duration))), hasPublicTransportsSection ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_Typography, {
    color: "textSecondary",
    component: "p",
    variant: "caption"
  }, toTime(cyclingDuration), "\xA0", /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "widget.routing.route_details.by_bike"
  })), /*#__PURE__*/React.createElement(_Typography, {
    color: "textSecondary",
    component: "p",
    variant: "caption"
  }, toDistance(cyclingDistance), "\xA0", /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "widget.routing.route_details.by_bike"
  }))) : /*#__PURE__*/React.createElement(_Typography, {
    color: "textSecondary",
    variant: "caption"
  }, toDistance(distance)), showDescription && description && /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(_Typography, {
    color: "textSecondary",
    variant: "caption"
  }, description))));
}
const Wrapper = styled.div``;
const StyledHeader = styled.div`
  align-items: center;
  display: flex;

  svg {
    margin-right: 4px;
  }
`;